export default "__VITE_ASSET__C9Pjc2Q1__"